/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React from "react";
import cn from "classnames";

interface IStack extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
  as?: string | React.JSXElementConstructor<any>;
  isFull?: boolean;
}

const Stack = React.forwardRef(
  (
    {
      className,
      children,
      isFull = true,
      as: Component = "div",
      ...rest
    }: IStack,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const rootClass = cn(`flex flex-col`, { "w-full": isFull }, className);
    return (
      <Component ref={ref} className={rootClass} {...rest}>
        {children}
      </Component>
    );
  },
);

export default Stack;
